import { format } from "date-fns";

export const formatUploadedString = (
  uploader: string | undefined,
  uploadDate: string,
) => {
  return `Uploaded by ${uploader || "patient"} on ${format(new Date(uploadDate), "M/d/yyyy 'at' h:mm a z")}`;
};
